/* eslint-disable no-underscore-dangle */
import { useEffect, useMemo, useRef } from 'react';
import { matchPath } from 'react-router-dom';
import { useOtherSettings } from '@namespace/cms';
import { useLocation } from '@namespace/i18n';
import { useSmarticoSuspendCallback } from '../useSmarticoSuspendCallback';

export const useSmarticoPopupSuspended = () => {
  const { pathname, search } = useLocation();
  const previousMatchRef = useRef(null);
  const { smarticoPopupExcludedRoutes = [] } = useOtherSettings();

  const suspendSmartico = useSmarticoSuspendCallback();

  const isMatch = useMemo(() => {
    const urlParams = new URLSearchParams(search);

    const matchedPath = smarticoPopupExcludedRoutes.find(
      ({ path: templatePath, query }) => {
        const pathMatch = matchPath(
          { path: templatePath, end: true },
          pathname
        );

        if (!pathMatch) {
          return false;
        }

        if (!query) {
          return true;
        }

        return Object.entries(query).every(
          ([key, value]) => urlParams.get(key) === value
        );
      }
    );

    return !!matchedPath;
  }, [pathname, search, smarticoPopupExcludedRoutes]);

  useEffect(() => {
    if (window._smartico?.suspendPopups) {
      if (previousMatchRef.current !== isMatch) {
        previousMatchRef.current = isMatch;
        suspendSmartico(isMatch, isMatch);
      }
    }
  }, [isMatch, suspendSmartico, window._smartico?.suspendPopups]);

  return isMatch;
};
